import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { obtenerPrestamos } from "../redux/actions/index";
import Swal from "sweetalert2";
import axios from "axios";

const ReportePrestamos = () => {
  const dispatch = useDispatch();
  const prestamos = useSelector((state) => state.prestamosrep);

  

  useEffect(() => {
    dispatch(obtenerPrestamos());
  }, [dispatch]);

  const generarRemitoPrestamo = async (prestamo) => {
    try {
      const remitoData = {
        id: prestamo.id,
        cliente: prestamo.cliente,
        usuario: prestamo.usuario,
        obra: prestamo.obra,
        productos: prestamo.productos.map((producto) => ({
          idProducto: producto.idProducto,
          nombreProducto: producto.nombreProducto,
          cantidad: producto.cantidad,
          unidadMedida: producto.unidadMedida,
        })),
        fechaPrestamo: prestamo.fecha,
        fechaDevolucion: prestamo.fechaDevolucion,
        estado: prestamo.estado,
      };
  
      // Solicitud para generar y descargar el PDF
      const response = await axios.post("/api/remitoPrestamos", remitoData, {
        responseType: "blob", // Configuración para manejar archivos binarios
      });
  
      // Crear un enlace para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `prestamo_${prestamo.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      Swal.fire({
        title: "Remito Generado",
        text: `El remito para el cliente ${prestamo.cliente} ha sido generado exitosamente.`,
        icon: "success",
        confirmButtonText: "Cerrar",
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Hubo un problema al generar el remito.",
        icon: "error",
        confirmButtonText: "Cerrar",
      });
    }
  };
  

  return (
    <div className="p-8 bg-backgroundClaro min-h-screen">
      <h2 className="text-2xl font-bold text-textoOscuro mb-4">Reporte de Préstamos</h2>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-400">
          <thead>
            <tr>
              <th className="border border-gray-400 text-textoOscuro p-2">Cliente</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Usuario</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Productos</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Cantidad</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Unidad Medida</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Obra</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Fecha de Préstamo</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Fecha de Devolución</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Estado</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {prestamos.length > 0 ? (
              prestamos.map((prestamo) => (
                <tr key={prestamo.id}>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.cliente}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.usuario}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.productos?.map((detalle) => (
                      <div key={detalle.id}>
                        {detalle.nombreProducto}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.productos?.map((detalle) => (
                      <div key={detalle.id}>
                        {detalle.cantidad}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.productos?.map((detalle) => (
                      <div key={detalle.id}>{detalle.unidadMedida}</div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.obra}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {new Date(prestamo.fecha).toLocaleString()}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {new Date(prestamo.fechaDevolucion).toLocaleString()}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {prestamo.estado}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    <button
                      className="bg-blue-500 text-textoOscuro px-4 py-2 rounded"
                      onClick={() => generarRemitoPrestamo(prestamo)}
                    >
                      Generar Remito
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="border border-gray-400 text-textoOscuro p-2" colSpan="9">
                  No hay préstamos registrados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportePrestamos;
